import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Box, CardActionArea, Grid, Typography } from '@mui/material';
import { useLocales } from 'src/locales';
import Iconify from 'src/components/iconify/Iconify';
import { Stack, padding } from '@mui/system';
import React from 'react';
import { Card, CardContent } from '@mui/material';
import { Icon } from '@iconify/react';
import { createOdooURL } from '../../routes/odooURL';

export default function ApplicationsPage() {
  const { translate } = useLocales();

  type IconifyIcon = string;

  interface CardData {
    icon: IconifyIcon;
    title: string;
    description: string;
    url?: string;
  }

  const cardsInvFab: CardData[] = [
    {
      icon: 'mdi:factory', // Icône représentant la fabrication ou l'industrie
      title: `${translate('upComingAppsPage.inventory.manufacturing.title')}`,
      description: `${translate(
        'upComingAppsPage.inventory.manufacturing.description'
      )}`,
      url: createOdooURL('manufacturing'),
    },
    {
      icon: 'mdi:package-variant', // Icône représentant un inventaire ou des stocks
      title: `${translate('upComingAppsPage.inventory.stock.title')}`,
      description: `${translate(
        'upComingAppsPage.inventory.stock.description'
      )}`,
      url: createOdooURL('stock'),
    },
    {
      icon: 'mdi:timeline-clock', // Icône représentant un processus ou un cycle de vie
      title: 'PLM',
      description: 'Gestion du cycle de vie d’un produit',
      url: createOdooURL('plm'),
    },
    {
      icon: 'mdi:cart-outline', // Icône représentant des achats ou des commandes
      title: `${translate('upComingAppsPage.inventory.purchase.title')}`,
      description: `${translate(
        'upComingAppsPage.inventory.purchase.description'
      )}`,
      url: createOdooURL('purchase'),
    },
    {
      icon: 'mdi:wrench', // Icône représentant la maintenance ou la réparation
      title: `${translate('upComingAppsPage.inventory.maintenance.title')}`,
      description: `${translate(
        'upComingAppsPage.inventory.maintenance.description'
      )}`,
      url: createOdooURL('maintenance'),
    },
    {
      icon: 'mdi:check-circle-outline', // Icône représentant le contrôle qualité
      title: `${translate('upComingAppsPage.inventory.quality.title')}`,
      description: `${translate(
        'upComingAppsPage.inventory.quality.description'
      )}`,
      url: createOdooURL('quality'),
    },
  ];

  return (
    <>
      <Helmet>
        <title> {`${translate('upComingAppsPage.title')}`} </title>
      </Helmet>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Typography
            variant="h3"
            paragraph
            align="center"
            sx={{ marginTop: '70px', marginBottom: '100px' }}
          >
            {`${translate('upComingAppsPage.appList')}`}
          </Typography>

          <Grid container spacing={12} sx={{ maxWidth: '1000px' }}>

            <Grid item>
              <Typography variant="h4" paragraph>
                {`${translate('upComingAppsPage.inventory.title')}`}
              </Typography>

              <Typography sx={{ marginBottom: '20px' }}>
                {`${translate('upComingAppsPage.inventory.description')}`}
              </Typography>

              <Grid container spacing={2}>
                {cardsInvFab.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card>
                      <CardActionArea
                        component="a"
                        href={card.url}
                        target="_bank"
                      >
                        <CardContent
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <div>
                            <Icon
                              icon={card.icon}
                              width={32}
                              style={{ marginRight: 16 }}
                            />
                          </div>
                          <div>
                            <Typography variant="h6">{card.title}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              {card.description}
                            </Typography>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Typography variant="h4" sx={{ marginTop: '80px' }} align="center">
            {`${translate('upComingAppsPage.footer.line1')}`} <br />
            {`${translate('upComingAppsPage.footer.line2')}`}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
